import { LayoutGrid, List } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export type ListCardsView = "list" | "cards";

export const ListCardsViewToggle = ({
  value,
  onValueChange
}: {
  value: ListCardsView;
  onValueChange: (value: ListCardsView) => void;
}) => {
  const handleViewChange = (next: string) => {
    if (next === "list" || next === "cards") {
      onValueChange(next);
    }
  };

  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={handleViewChange}
      variant="outline"
      size="sm"
    >
      <ToggleGroupItem value="list" aria-label="List view" className="h-8">
        <List className="h-3.5 w-3.5" />
      </ToggleGroupItem>
      <ToggleGroupItem value="cards" aria-label="Cards view" className="h-8">
        <LayoutGrid className="h-3.5 w-3.5" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
